import { useLocation, useNavigate } from 'react-router-dom';
import {
  Package, ShoppingCart, ArrowLeftRight, ClipboardList, Clock,
  Plus, Printer, BarChart3, FileText, RefreshCw, Download
} from 'lucide-react';

const PAGE_ACTIONS = {
  '/inventory': [
    { label: 'Add Item', icon: Plus, action: 'navigate', path: '/inventory?action=add' },
    { label: 'Create PO', icon: ShoppingCart, action: 'navigate', path: '/purchase-orders?action=add' },
    { label: 'Transfer', icon: ArrowLeftRight, action: 'navigate', path: '/stock-transfers' },
    { label: 'Reports', icon: BarChart3, action: 'navigate', path: '/inventory-reports' },
  ],
  '/sales': [
    { label: 'New Sale', icon: Plus, action: 'navigate', path: '/sales?action=new' },
    { label: 'Reports', icon: BarChart3, action: 'navigate', path: '/sales/reports' },
    { label: 'Returns', icon: RefreshCw, action: 'navigate', path: '/sales-advanced' },
  ],
  '/purchase-orders': [
    { label: 'New PO', icon: Plus, action: 'navigate', path: '/purchase-orders?action=add' },
    { label: 'Receiving', icon: Package, action: 'navigate', path: '/receiving' },
    { label: 'Suppliers', icon: FileText, action: 'navigate', path: '/suppliers' },
  ],
  '/production': [
    { label: 'New Batch', icon: Plus, action: 'navigate', path: '/production?action=add' },
    { label: 'Recipes', icon: ClipboardList, action: 'navigate', path: '/recipes' },
    { label: 'Planning', icon: Clock, action: 'navigate', path: '/production/planning' },
    { label: 'Quality', icon: FileText, action: 'navigate', path: '/production/quality' },
  ],
  '/suppliers': [
    { label: 'Add Supplier', icon: Plus, action: 'navigate', path: '/suppliers?action=add' },
    { label: 'Create PO', icon: ShoppingCart, action: 'navigate', path: '/purchase-orders?action=add' },
  ],
  '/recipes': [
    { label: 'New Recipe', icon: Plus, action: 'navigate', path: '/recipes?action=add' },
    { label: 'Production', icon: Package, action: 'navigate', path: '/production' },
  ],
  '/finance': [
    { label: 'Reports', icon: BarChart3, action: 'navigate', path: '/finance?tab=reports' },
    { label: 'Export', icon: Download, action: 'navigate', path: '/data-import-export' },
  ],
};

function ContextualActionBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname;
  const actions = PAGE_ACTIONS[currentPath];

  if (!actions || actions.length === 0) return null;

  return (
    <div className="fixed bottom-20 lg:bottom-6 left-1/2 -translate-x-1/2 z-40">
      <div className="bg-[#0F172A] rounded-2xl shadow-2xl border border-white/10 px-2 py-2 flex items-center gap-1">
        {actions.map((act, idx) => {
          const Icon = act.icon;
          return (
            <button
              key={idx}
              onClick={() => {
                if (act.action === 'navigate') navigate(act.path);
              }}
              className="flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium text-slate-300 hover:text-white hover:bg-white/10 transition-all whitespace-nowrap"
              title={act.label}
            >
              <Icon className="w-4 h-4" />
              <span className="hidden sm:inline">{act.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ContextualActionBar;
